export default __webpack_public_path__ + "static/media/network-back_540.8503b76d.png";